// LiveRackView.tsx

import React from 'react';
import LiveRack from './LiveRack';
import styles from './LiveRackView.module.scss';
import { LiveRepFrame } from '../../types/automatic';

interface LiveRackViewProps {
  stationIds: string[];
  racksAggregatedData: Record<
    string,
    {
      stationNumber?: number;
      currentMember?: string | null;
      status?: string;
      rtServiceOnline?: boolean;
      data: Record<string, LiveRepFrame[]>;
      order: string[];
      activeUserId: string | null;
    }
  >;
  stationIndexMap: Record<string, number>;
  onRackClick?: (rackNumber: number) => void;
}

const LiveRackView: React.FC<LiveRackViewProps> = ({
  stationIds,
  racksAggregatedData,
  stationIndexMap,
  onRackClick,
}) => {
  return (
    <div className={styles.rackView}>
      {stationIds.map((sid) => {
        const agg = racksAggregatedData[sid];
        const displayNumber = agg?.stationNumber ?? stationIndexMap[sid] ?? 0;
        return (
          <LiveRack
            key={sid}
            number={displayNumber}
            data={agg?.data || {}}
            activeUserId={agg?.activeUserId || null}
            status={agg?.status}
            rtServiceOnline={agg?.rtServiceOnline}
            currentMemberId={agg?.currentMember ?? null}
            onClick={onRackClick}
          />
        );
      })}
    </div>
  );
};

export default LiveRackView;
